import { autoinject } from "aurelia-framework";
import { applicationLogger } from "../logging/logger";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { GreenhouseDataEvents } from "../events/data-events";
import { NotificationRecipient } from "../models/notification-recipient";
import * as Enumerable from 'linq-es2015';


export class NotificationType {
    id: number;
    name: string;
}
@autoinject
export class NotificationTypeSelector {
 
    selectedNotificationType: NotificationType;
    notificationRecipient: NotificationRecipient;
    notificationTypes: NotificationType[];
    private readonly eventAggregator: EventAggregator;
    private locationsLoadedSubscription: Subscription;

    constructor(eventAggregator: EventAggregator) {
        this.eventAggregator = eventAggregator;
        this.notificationTypes = [
            { id: 0, name: "None" }, { id: 1, name: "SMS" }, { id: 2, name: "Email" }, { id: 3, name: "SMS & Email" }
        ];

    }

  bind(bindingContext: any, overrideContext: any) {
      this.notificationRecipient = bindingContext.notificationRecipient;
      this.selectedNotificationType = this.getNotificationType(this.notificationRecipient.notificationType);
    }

    getNotificationType(id: number): NotificationType {
        const enumerable = Enumerable.AsEnumerable(this.notificationTypes);
        return enumerable.FirstOrDefault(type => type.id === id);
    }


    notificationTypeChanged() {
        this.notificationRecipient.notificationType = this.selectedNotificationType.id;
        this.eventAggregator.publish(GreenhouseDataEvents.notificationRecipientUpdated, this.notificationRecipient);
    }

}